import { defineStore } from 'pinia'
import { GAME_PCODE_CONFIG } from '@/hooks/useGameConfig'
import { ILevelRule, ILevelRuleConfig, IMoyuModel, IPayGuideConfig } from "@/@types/types";

export const useCommonStatus = defineStore('commonStatus', {
  state: () => ({
    showHelp: false,
    orderRecordVisible: false,
    orderDetailVisible: false,
    usdkOrder: '',
    payData: {} as any,
    authVisible: false,
    feedbackVisible: false,
    // 是否是摸鱼社app
    isMoyuApp: navigator.userAgent.includes('Hero'),
    // isMoyuApp: true,
    isWeixin: navigator.userAgent.toLowerCase().includes('micromessenger'),
    noReminderTodayActivity: '',
    priceSaving: '',
    priceSavingCurrency: '',

    // 支付loading
    payLoadingVisible: false,
    // 支付遇到问题
    payProblemVisible: false,
    // 支付成功弹窗
    paySuccessVisible: true,
    // 活动中心弹窗
    activityCenterVisible: false,
    // 代金券活动弹窗
    voucherActivityVisible: false,
    // 赠送活动弹窗
    limitRebateVisible: false,
    // 免费礼包领取成功弹窗
    freeGiftSuccessVisible: false,
    // 微信支付弹窗
    wechatPayVisible: false,
    // 微信内点击授权登录，弹出提示
    guideVisible: false,
    // home页面请求loading
    homeReqLoading: false,
    // 授权弹窗
    authLoginTipsVisible: false,
    // 首充弹窗
    firstChargeVisible: false,
  //   选择子账号
    visibleSubList: false,
  //   手机号登录选择子账号
    visiblePhoneList: false,
    phoneAccountList: [],
    deferredPrompt: null as any,

    cartIconRef: null as HTMLElement | null,
    cartIconRefMobile: null as HTMLElement | null,
    payGuideConfList: [] as IPayGuideConfig[],
    levelRuleConfListData: [] as ILevelRuleConfig[],
    levelRuleDesc: {} as ILevelRule | null,
  }),
  actions: {
    setPaySuccessVisible(paySuccess: boolean) {
      this.paySuccessVisible = paySuccess
    },
    setPayLoadingVisible(Visible: boolean) {
      this.payLoadingVisible = Visible
    },
    setPayProblemVisible(Visible: boolean) {
      this.payProblemVisible = Visible
    },
    setUsdkOrder(usdkOrder: string) {
      console.log('usdkOrder', usdkOrder)
      this.usdkOrder = usdkOrder || ''
    },
    setActivityCenterVisible(Visible: boolean) {
      this.activityCenterVisible = Visible
    },
    setVoucherActivityVisible(Visible: boolean) {
      this.voucherActivityVisible = Visible
    },
    setLimitRebateVisible(Visible: boolean) {
      this.limitRebateVisible = Visible
    },
    setFreeGiftSuccessVisible(Visible: boolean) {
      this.freeGiftSuccessVisible = Visible
    },
    setGuideVisible(Visible: boolean) {
      this.guideVisible = Visible
    },
    setAuthLoginTipsVisible(Visible: boolean) {
      this.authLoginTipsVisible = Visible
    },
    setFirstChargeVisible(Visible: boolean) {
      this.firstChargeVisible = Visible
    },
    setWechatPayVisible(Visible: boolean) {
      this.wechatPayVisible = Visible
    },
    setPayData(data: any) {
      this.payData = data
    },
    setMoyuToken(token: string) {
      const localTokens = JSON.parse(localStorage.getItem('mysTokens') || '{}')
      // 先取出当前游戏的本地token
      const localAccessToken = localTokens[window.globalRoute.path]
      localTokens[window.globalRoute.path] = token || ''
      localStorage.setItem('mysTokens', JSON.stringify(localTokens))
      // 获取的token和本地存储的token不相等，说明是切换账号了，清除本地账号缓存
      if (localAccessToken !== token) {
        localStorage.removeItem('gameRoleInfo')
      }
    },
    async loadMoyuJsSdk(path: string, cb: () => void) {
      const s = document.createElement('script')
      s.src = `//herobox-cdn.yingxiong.com/h5/js/moyu-js-sdk-shop.js?${+new Date()}`
      s.onload = () => {
        try {
          window.moyuJSSDK.init({
            dev: (process.env.BASE_ENV as string) !== 'cn_mall',
            // dev: true,
            pcode: GAME_PCODE_CONFIG[path] || 0,
            fail: (err: any) => {
              console.log("摸鱼社初始化失败", err)
            },
            success: (res: IMoyuModel) => {
              console.log("摸鱼社初始化成功", res)
              const {token} = res;
              if(!token) {
                window.moyuJSSDK.login({
                  success: (token: string) => {
                    console.log("token", token)
                    this.setMoyuToken(token);
                    cb && cb()
                  },
                })
                return;
              }
              // res.token = 'de80df53-51b9-407c-ae59-577360d3b5e3'
              // const localAccessToken = localStorage.getItem('accessToken')
              // localStorage.setItem('accessToken', (res.token as string) || '')
              this.setMoyuToken(token);
              cb && cb()
            }
          })
        } catch (e) {
          console.log(e)
        }
      }
      document.head.appendChild(s)
    },
    setShowHelp(showHelp: boolean) {
      this.showHelp = showHelp
    },
    setOrderRecordVisible(orderRecordVisible: boolean) {
      this.orderRecordVisible = orderRecordVisible
    },
    setAuthVisible(authVisible: boolean) {
      this.authVisible = authVisible
    },
    setFeedbackVisible(visible: boolean) {
      this.feedbackVisible = visible
    },
    setNoReminderActivity(val: string) {
      this.noReminderTodayActivity = val
    },
    getOrigin(isMobile: boolean) {
      let source = 1
      if (isMobile) {
        source = 2
      }
      if (this.isMoyuApp) {
        source = 3
      }
      if (this.isWeixin) {
        source = 4
      }
      return source
    }
  },
  persist: {
    key: '__hero_mall_common__',
    storage: localStorage,
    paths: ['noReminderTodayActivity', 'payLoadingVisible', 'usdkOrder', 'payData']
  }
})
